export const TOKEN_REFRESH_PARAM = 'forceRefresh';
